import { Widgets } from '@common/enums';

/**
 * Grouping used by the widget picker (add-widget modal, block drawer) to split
 * the flat widget list into labelled sections.
 */
export type WidgetGroup = 'course' | 'common';

/**
 * Widgets surfaced under the "courses" group in the widget picker — the
 * EDU-oriented widgets (student login form, the EDU-login button and the
 * testimonials widget). Everything else falls under "common".
 */
export const COURSE_WIDGET_NAMES: ReadonlySet<Widgets> = new Set<Widgets>([
    Widgets.LOGIN_EDU,
    Widgets.EDU_LOGIN_BUTTON,
    Widgets.TESTIMONIAL,
]);

export const isCourseWidget = (name: Widgets | string): boolean => COURSE_WIDGET_NAMES.has(name as Widgets);
